export const msalConfig = {
    auth: {
      clientId: '2b239a17-89c3-4172-bb9d-7b5b2e079630',
      authority: 'https://login.microsoftonline.com/37ff5b72-7da1-48eb-b51c-fd47be09baaa',
      redirectUri: 'http://localhost:3000',
    },
  };
  
  export const loginRequest = {
    scopes: ['openid', 'profile', 'User.Read'],
  };
  